import React from 'react';

import b_ from 'b_';
import {useFeedback} from '@yandex-int/pythia-feedback';

import {Link} from 'client/common/components/lego';
import {createUrl} from 'client/common/utils/history';
import I18N from 'assets/i18n/brandlift-project';
import cfg from 'client/common/utils/client-config';

import {ComponentProps} from './types';

import './footer.css';

const i18n = I18N.common.footer;
const b = b_.with('footer');

const OFFER_URL = 'https://yandex.ru/legal/oferta_surveys/';
const FEEDBACK_URL =
    'https://yandex.ru/poll/enter/C8Hh2D3JLPRG1TamMjprgt?from=header-mini&surveys-login=%s';
const SURVEYS_URL = 'https://surveys.yandex.ru';

export default function Footer(props: ComponentProps) {
    const {login} = props;

    const year = new Date().getFullYear();

    useFeedback(
        cfg.feedbackOwnerId,
        {
            from: 'header-mini',
            'surveys-login': login || '',
            'from-href': window.location.href
        },
        {environment: cfg.feedbackEnvironment, forceTheme: 'light'}
    );

    return (
        <footer className={b()}>
            <div className={b('links')}>
                <Link
                    href={createUrl({link: OFFER_URL})}
                    rel='noopener noreferrer'
                    target='_blank'
                    view='default'
                >
                    {i18n.offer}
                </Link>
                <Link
                    href={createUrl({link: i18n.rulesUrl})}
                    rel='noopener noreferrer'
                    target='_blank'
                    view='default'
                >
                    {i18n.rules}
                </Link>
                <Link
                    href={createUrl({link: i18n.ArticlesUrl})}
                    rel='noopener noreferrer'
                    target='_blank'
                    view='default'
                >
                    {i18n.articles}
                </Link>
                <Link
                    href={createUrl({link: i18n.NewsURL})}
                    rel='noopener noreferrer'
                    target='_blank'
                    view='default'
                >
                    {i18n.news}
                </Link>
                <Link
                    href={createUrl({link: FEEDBACK_URL.replace('%s', login ?? '')})}
                    rel='noopener noreferrer'
                    target='_blank'
                    view='default'
                >
                    {i18n.feedback}
                </Link>
            </div>
            <div className={b('copyright')}>
                {i18n.copyright[0].replace('%s', year.toString())}
                <Link
                    href={createUrl({link: SURVEYS_URL})}
                    rel='noopener noreferrer'
                    target='_blank'
                    view='default'
                >
                    {i18n.surveys}
                </Link>
                {i18n.copyright[1]}
            </div>
        </footer>
    );
}
